// extracted by mini-css-extract-plugin
export default {"row":"word_row__ch3pf"};